<template>
<div class="chapter">
<div class="inner_page">
<div class="img_container">
<p class="image"><a id="page_1"></a><img alt="" src="images/author.jpg"/></p>
</div>
<p class="author"><a id="page_2"></a><span class="blub">Sarah-Jane Hicks</span> has always enjoyed crochet and crafting in her spare time. She was taught to crochet as a child by her mum and nan. Previously she worked as a tax adviser and is now a freelance crochet designer. She has had patterns published in various popular craft and crochet magazines. She has over 42K followers on her Instagram account: <a href="https://www.instagram.com/flo_and_dot/" target="_blank">@flo_and_dot</a>, and her blog can be seen at: <a href="http://floanddot.blogspot.com" target="_blank">floanddot.blogspot.com</a>. Sarah-Jane lives in Norfolk in the UK.</p>
<div class="img_container">
<p class="image"><img alt="" src="images/fm01.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Author.vue?27c88bfe